import { render, staticRenderFns } from "./BaseToolbarUserAvatar.vue?vue&type=template&id=7c3d62a5&scoped=true&"
import script from "./BaseToolbarUserAvatar.vue?vue&type=script&lang=js&"
export * from "./BaseToolbarUserAvatar.vue?vue&type=script&lang=js&"
import style0 from "./BaseToolbarUserAvatar.vue?vue&type=style&index=0&id=7c3d62a5&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c3d62a5",
  null
  
)

export default component.exports